import React from "react";
import InputMask from "react-input-mask";
import { TextField } from "@material-ui/core";

import { StyledInvoiceAttrInputWrapper } from "../styledInvoice";

const InvoiceAttributeWithMask = ({ mask, maskChar, value, onChange, error, helperText, id, label, placeholder }) => {
  return (
    <InputMask
      mask={mask}
      maskChar={maskChar}
      onChange={onChange}
    >
      {() => (
        <TextField
          id={id}
          label={label}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
        />
      )}
    </InputMask>
  );
};

export default InvoiceAttributeWithMask;